import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import HrStore from './Context/HrStore';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HrStore>
      <App />
    </HrStore>
  </React.StrictMode>
);

reportWebVitals();
